export const SITE = {
  url: "https://www.orkestsolutions.com",
  email: "info@orkestsolutions.com",
  careersEmail: "careers@orkestsolutions.com",
  name: { en: "Orkest Digital Solutions", ar: "أوركست لتكنولوجيا المعلومات" },
  location: { en: "Cairo, Egypt", ar: "القاهرة، مصر" },
  socials: [
    { name: "Facebook", id: "facebook", url: "https://www.facebook.com/orkestsolutions" },
    { name: "LinkedIn", id: "linkedin", url: "https://www.linkedin.com/company/orkestsolutions" },
    { name: "Instagram", id: "instagram", url: "https://www.instagram.com/orkestsolutions" },
    { name: "GitHub", id: "github", url: "https://github.com/Orkest-Solutions" },
  ],
}
